module.exports = __webpack_public_path__ + "8e0860f3581b197e9fa4713a706c7bcc.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Light.woff2
// module id = 337
// module chunks = 0